import { Controller } from "@hotwired/stimulus"
import { getLogsToday, purgeOldLogs, saveLog } from "../../pwa/offline_queue"

// Connects to data-controller="attandances--record-log"
export default class extends Controller {
  static targets = ["container", "empty"]
  async connect() {
    await purgeOldLogs()
    await this.restoreOfflineLogs()
    this.observeNewLogs()
  }

  disconnect() {
    this.logObserver?.disconnect()
  }

  observeNewLogs() {
    if (!this.hasContainerTarget) return

    const observer = new MutationObserver(async (mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue
          if (!node.classList.contains("record-item")) continue

          if (node.dataset.alreadySaved === "true") continue

          const message = node.textContent?.trim()
          if (!message) continue

          await saveLog(message)
        }
      }
    })

    observer.observe(this.containerTarget, {childList: true})
    this.logObserver = observer
  }

  async restoreOfflineLogs() {
    if (!this.hasContainerTarget) return

    const logs = await getLogsToday()
    if (logs.length === 0) return

    if (this.hasEmptyTarget) this.emptyTarget.remove()

    logs.forEach(log => {
      const alreadyExists = [...this.containerTarget.children]
        .some(el => el.textContent?.trim() === log.message)
      if (alreadyExists) return

      const div = document.createElement("div")
      div.className = "record-item"
      div.textContent = log.message
      this.containerTarget.insertBefore(div, this.containerTarget.firstChild)
    })
  }
}
